var generateStyle = function generateStyle(componentTheme) {
  return {
    alert: {
      paddingBottom: componentTheme.alertBottomPadding
    },
    errorAlert: {
      flexBasis: '80%'
    },
    radioInputGroup: {
      paddingBottom: componentTheme.radioInputGroupBottomPadding
    },
    select: {
      padding: '0 1.6rem componentTheme.selectPadding'
    }
  };
};
export default generateStyle;